export const NAME = 'taskForwarding';

export const dialogs = {
	validation_error: `${NAME}/validation_error`,
	taskAmountToForwardLimit: `${NAME}/taskAmountToForwardLimit`,
};

export const TASK_FORWARDING_HAS_NO_ACCESS_ERR_MSG = 'has no access to task';
export const TASK_FORWARDING_ALREADY_PROCESSED = 999000006;
